import { render, staticRenderFns } from "./safaricom.vue?vue&type=template&id=e1ebd75e"
import script from "./safaricom.vue?vue&type=script&lang=js"
export * from "./safaricom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports